'use strict';

var NetworkEvent = require('./NetworkEvent.cjs');

class AxiosExceptionEventData extends NetworkEvent {
  static isAxiosErrorHint(hint) {
    return Boolean(hint?.originalException?.isAxiosError);
  }
  constructor(event, hint) {
    super(event);
    this.hint = hint;
    this.extra = event.extra;
  }
  getRawIdentity() {
    return this.hint.originalException.config.identifier;
  }
  getRawMethod() {
    return this.hint.originalException.config.method;
  }
  getRawStatus() {
    return this.hint.originalException.response?.status;
  }
  getRawEndPoint() {
    return this.hint.originalException.config.url;
  }
  getRawCode() {
    return this.hint.originalException.response?.data?.code;
  }
  getRawMessage() {
    return this.hint.originalException.response?.data?.message;
  }
  getRawExtra() {
    const { extra } = this;
    const { response } = this.hint.originalException;
    const data = response?.data;
    const headers = response?.headers;
    return {
      ...extra,
      data,
      headers
    };
  }
}

module.exports = AxiosExceptionEventData;
//# sourceMappingURL=AxiosEvent.cjs.map
